import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/lib/motion";
import { FAQS } from "@/data/content";
import { SEO } from "@/components/SEO";

const FAQ = () => (
  <div data-testid="faq-page">
    <SEO
      title="Frequently asked questions"
      description="Answers to common questions about Risi Wellness mobile massage and wellness appointments."
      pathname="/faq"
      schema={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQS.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      }}
    />
    <PageHero eyebrow="Good to Know" title="Frequently asked questions"
      subtitle="Everything you need to know before your first Risi Wellness treatment." />

    <section className="max-w-3xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
      <Reveal>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="rounded-2xl border border-border bg-card px-6 overflow-hidden">
              <AccordionTrigger className="text-left font-serif text-xl text-primary hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-14 text-center rounded-3xl bg-primary text-primary-foreground p-10">
          <h2 className="font-serif text-3xl mb-3">Still have a question?</h2>
          <p className="text-primary-foreground/80 mb-6">We're always happy to help.</p>
          <Link to="/contact" className="inline-flex items-center gap-2 rounded-full bg-secondary text-secondary-foreground px-8 py-3.5 font-semibold hover:bg-secondary/90 transition-colors">Contact us <ArrowUpRight size={17} /></Link>
        </div>
      </Reveal>
    </section>
  </div>
);

export default FAQ;
